var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_95)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_95",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0H0V23H23V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.623 11.5C12.623 12.1202 12.1202 12.623 11.5 12.623C10.8798 12.623 10.377 12.1202 10.377 11.5C10.377 10.8798 10.8798 10.377 11.5 10.377C12.1202 10.377 12.623 10.8798 12.623 11.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1152 11.5C17.1152 12.1202 16.6124 12.623 15.9922 12.623C15.372 12.623 14.8691 12.1202 14.8691 11.5C14.8691 10.8798 15.372 10.377 15.9922 10.377C16.6124 10.377 17.1152 10.8798 17.1152 11.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13086 11.5C8.13086 12.1202 7.62805 12.623 7.00781 12.623C6.38758 12.623 5.88477 12.1202 5.88477 11.5C5.88477 10.8798 6.38758 10.377 7.00781 10.377C7.62805 10.377 8.13086 10.8798 8.13086 11.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_95)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2_95",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H23V23H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.898439C5.64493 0.898439 0.898438 5.64493 0.898438 11.5C0.898438 13.5612 1.48732 15.4847 2.50511 17.1124L0.898438 22.1016L5.8876 20.4949C7.51534 21.5127 9.43876 22.1016 11.5 22.1016C17.3551 22.1016 22.1016 17.3551 22.1016 11.5C22.1016 5.64493 17.3551 0.898439 11.5 0.898439Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.623 11.5C12.623 12.1202 12.1202 12.623 11.5 12.623C10.8798 12.623 10.377 12.1202 10.377 11.5C10.377 10.8798 10.8798 10.377 11.5 10.377C12.1202 10.377 12.623 10.8798 12.623 11.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1152 11.5C17.1152 12.1202 16.6124 12.623 15.9922 12.623C15.372 12.623 14.8691 12.1202 14.8691 11.5C14.8691 10.8798 15.372 10.377 15.9922 10.377C16.6124 10.377 17.1152 10.8798 17.1152 11.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13086 11.5C8.13086 12.1202 7.62805 12.623 7.00781 12.623C6.38758 12.623 5.88477 12.1202 5.88477 11.5C5.88477 10.8798 6.38758 10.377 7.00781 10.377C7.62805 10.377 8.13086 10.8798 8.13086 11.5Z",
    fill: "currentColor"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.65b99152afdc1733b83982742e60a571.svg";
export { ForwardRef as ReactComponent };